<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    height:inherit;
    font-family:"微软雅黑","Helvetica","宋体";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background:#f9f9f9;
  }
.el-menu{
  border-right:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue